import { connect } from 'react-redux'
import { boardDefSet } from '../../store/boardDef'
import BoardSelector from './BoardSelector'

const mapStateToProps = (state, ownProps) => {
  return {
    boardDefs: state.boardDefs || {},
    selected: state.boardDef || ''
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    setSelectedBoard: (id) => { dispatch(boardDefSet(id)) }
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(BoardSelector)



// WEBPACK FOOTER //
// ./src/components/BoardSelector/index.js